// extracted by mini-css-extract-plugin
module.exports =  {"reportTitle":"reportTitle_I1lDviZF"};